import { Button } from "@mui/material";

import useI18N from "../hooks/useI18N";
import { MUIStyled } from "./MUIStyled";
import SALoader from "./SALoader";

const StyledButton = MUIStyled(Button, {
  shouldForwardProp: (prop) => prop !== "dir",
})(({ theme, dir }) => ({
  padding: "7px 20px",
  fontSize: 16,
  minWidth: 100,
  fontWeight: 600,
  lineHeight: "normal",
  textTransform: "capitalize",
  borderRadius: 0,

  "&.MuiButton-contained": {
    backgroundColor: "#CCB16A",
    color: theme.palette.common.white,
    border: "1px solid transparent",
    fontWeight: 450,
    "&.Mui-disabled": {
      backgroundColor: "#f5f5f5",
      color: theme.palette.text.disabled,
      border: "1px solid #ddd",
    },
  },
  "&.MuiButton-textError": {
    border: "none",
    fontWeight: "400",
    "&:hover": { backgroundColor: "transparent" },
  },
  "&.MuiButton-textPrimary": {
    border: "none",
    fontWeight: "400",
    "&:hover": { backgroundColor: "transparent" },
  },
  "&.MuiButton-sizeSmall": {
    padding: "6px 12px",
    fontSize: 14,
    minWidth: 60,
  },
  "& .MuiButton-icon": {
    marginRight: dir === "rtl" ? 10 : 0,
    marginLeft: dir === "rtl" ? 0 : 10,
  },
}));

const SAButton = ({ children, disabled, loading, ...rest }) => {
  const { dir } = useI18N();
  return (
    <StyledButton
      dir={dir}
      disableElevation
      disabled={disabled || loading}
      endIcon={loading ? <SALoader size={18} /> : null}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default SAButton;
